/**
 * Reading values back out of a reference payload.
 *
 * A reference arrives as `Record<string, unknown>` -- the backend column is
 * JSON, and only the section that wrote it knows what should be inside. These
 * turn "whatever came over the wire" into something a resolver can use, so a
 * payload that has drifted produces a reference that lands somewhere sensible
 * rather than a route built from `undefined`.
 *
 * Deliberately about shape only: no section's schema is known here.
 */

export function referenceNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

export function referenceString(value: unknown): string | undefined {
  return typeof value === 'string' && value ? value : undefined;
}

export function referenceNumberList(value: unknown): number[] {
  return Array.isArray(value)
    ? value.filter((item): item is number => referenceNumber(item) !== null)
    : [];
}
